let classNames = (...names) => {
  return names.filter(name=>(!!name)).join(' ')
}

export default classNames


// WEBPACK FOOTER //
// ./src/etc/class-names.js